import React from 'react'
import { LayoutAnimation, Platform } from 'react-native'
import { type ScopedProps, useAccordionContext } from '../../accordion'
import * as S from './item.styles'

type TItemProps = {
  children: React.ReactNode
  index?: number
  defaultExpanded?: boolean
}

if (Platform.OS === 'android') {
  LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut)
} else {
  LayoutAnimation.configureNext(LayoutAnimation.Presets.linear)
}

export function Item(props: TItemProps) {
  const { __scopeAccordion, children, index } = props as ScopedProps<TItemProps>
  const { expandedIndex, setExpandedIndex, disabled } = useAccordionContext(
    'AccordionItem',
    __scopeAccordion
  )
  const isCollapsed = expandedIndex !== index

  const handleToggle = () => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut)
    setExpandedIndex(isCollapsed ? index! : null)
  }

  return (
    <S.Item onPress={handleToggle} disabled={disabled}>
      {React.Children.map(children, child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, { index } as { index: number })
        }
        return child
      })}
    </S.Item>
  )
}

Item.displayName = 'Accordion.Item'
